import { render, staticRenderFns } from "./BulkClaimsTable.vue?vue&type=template&id=28e30d9e&scoped=true"
import script from "./BulkClaimsTable.vue?vue&type=script&lang=js"
export * from "./BulkClaimsTable.vue?vue&type=script&lang=js"
import style0 from "./BulkClaimsTable.vue?vue&type=style&index=0&id=28e30d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e30d9e",
  null
  
)

export default component.exports